import React from 'react';
import Select, { components } from 'react-select';
import { ErrorMessage, Field } from 'formik';
import countries from '../../Data/countries';
import 'flag-icon-css/less/flag-icon.less';

const Option = ({ children, className, ...props }) => {
  return (
    <components.Option {...props} className="option-wrapper">
      <span className={`flag-icon flag-icon-${props.data.value.toLowerCase()}`} />
      <span className="flag-name">{children}</span>
    </components.Option>
  );
};

const SingleValue = ({ children, ...props }) => {
  return (
    <div className="single-value-wrapper">
      <span className={`flag-icon flag-icon-${props.data.value.toLowerCase()}`} />
    </div>
  );
};

const PhoneFieldWithCountryFlag = ({ field, form }) => {
  
  const { value, name } = field;
  const { country } = value;

  // const country = 'NZ';
  const defaultCountry = countries.find((c) => c.value === country);

  return (
    <div className="phone-field">
      <div className="country">
        <Select
          inputProps={{ autoComplete: 'nope' }}
          options={countries}
          autoComplete="nope"
          // menuIsOpen={true} 
          isDisabled={value.countrySameAsPrimary}
          onChange={(e) => {
            form.setFieldValue(`${name}.country`, e.value);
            if (form.values.level == 'friend') {
              let i;
              for (i = 0; i < form.values.friendsArray.length; i++) {
                if (document.getElementById(`friend-${i}-same-phone`).checked) {
                  form.setFieldValue(`friendsArray[${i}][phone].country`, e.value);
                }
              }
            }
          }}
          onBlur={field.onBlur}
          components={{
            Option,
            SingleValue,
          }}
          value={defaultCountry}
        />
      </div>
      <div className="number">
        <Field
          name={`${name}.number`}
          autoComplete="nope"
          id={`${name}.number`}
          type="tel"
          onChange={(e) => {
            form.handleChange(e);
            if (form.values.level == 'friend' && e.target.id == "phone.number") {
              let i;
              for (i = 0; i < form.values.friendsArray.length; i++) {
                if (document.getElementById(`friend-${i}-same-phone`).checked) {
                  form.setFieldValue(`friendsArray[${i}][phone].number`, e.target.value);
                }
              }
            }
          }}
        />
      </div>
      <ErrorMessage name="phone">
        {(msg) => (
          <ul className="validationErrors">
            <li id="phone-error" className="formValidationError">
              {msg}
            </li>
          </ul>
        )}
      </ErrorMessage>
    </div>
  );
};

export default PhoneFieldWithCountryFlag;

// import React from 'react';
// import { ErrorMessage, Field } from 'formik';
// import countries from '../../Data/countries';
// import 'flag-icon-css/less/flag-icon.less';
//
// const PhoneFieldWithCountryFlag = () => (
//   <>
//     {/*{countries.map((country) => {*/}
//     {/*  return (*/}
//     {/*<div className="single-value-wrapper">*/}
//     {/*  <span className={`flag-icon flag-icon-${country.value.toLowerCase()}`} />*/}
//     {/*</div>*/}
//     {/*  );*/}
//     {/*})}*/}
//
//     <li className="form-field form-field-option">
//       <label className="required">Country:</label>
//       <Field as="select" name="phone.country">
//         {countries.map((country) => {
//           return (
//             <option key={country.value} value={country.value}>
//                {/*<div className="single-value-wrapper">*/}
//                {/* <span className={`flag-icon flag-icon-${country.value.toLowerCase()}`} />*/}
//                {/*</div>*/}
//               {country.label}
//             </option>
//           );
//         })}
//         ;
//       </Field>
//     </li>
//     <li className="form-field">
//       <label className="required">Phone:</label>
//       <Field name="phone.number" type="text" id="phone" />
//     </li>
//     <ErrorMessage name="phone">
//       {(msg) => (
//         <ul className="validationErrors">
//           <li id="phone-error" className="formValidationError">
//             {msg}
//           </li>
//         </ul>
//       )}
//     </ErrorMessage>
//   </>
// );
//
// export default PhoneFieldWithCountryFlag;
